const BARRONS_PRINT_GRID = {
  offsetY: 3.2,
  headlineMargin: 8,
  notesMargin: 8,
  line: 9,
  columns: [
    173.0,
    358.0,
    543.0,
    728.0
  ],
};

export default BARRONS_PRINT_GRID;
